export default function Logo() {
  return (
    <div className="defeated-image">
      <img src="/img/defeatedWarrior.png" alt="War &amp; Peace Defated Image" />
    </div>
  );
}
